import { useDispatch, useSelector } from "react-redux";
import { setShowMassage } from "../store/sysSlice";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import { useEffect, useState } from "react";
import {
  CheckCircleOutlined,
  Close,
  ErrorOutlineOutlined,
  ReportGmailerrorredOutlined,
} from "@mui/icons-material";
import {
  IconButton,
  Slide,
  Snackbar,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

function SlideTransition(props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return <Slide {...props} direction={isMobile ? "up" : "right"} />;
}

const ShowMassage = () => {
  const theme = useTheme();
  const { bt } = useBizTypeTranslation();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const data = useSelector((state) => state?.sys.showMassage);
  const [massage, setMassage] = useState("");
  const [type, setType] = useState("");

  const TYPE = [
    {
      name: "info",
      icon: <ErrorOutlineOutlined sx={{ color: "black" }} />,
      color: "black",
    },
    {
      name: "error",
      icon: <ReportGmailerrorredOutlined sx={{ color: "red" }} />,
      color: "red",
    },
    {
      name: "success",
      icon: <CheckCircleOutlined sx={{ color: "green" }} />,
      color: "green",
    },
  ];

  useEffect(() => {
    if (data?.massage) {
      setMassage(data.massage);
      const findType = TYPE.find((t) => t.name === data.type);
      if (findType) setType(findType);
      else setType(TYPE[0]);
    }
  }, [data]);

  const handleClose = () => {
    dispatch(setShowMassage(null));
  };

  return (
    <Snackbar
      open={data ? true : false}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: isMobile ? "center" : "right",
      }}
      TransitionComponent={SlideTransition}
      autoHideDuration={3500}
      onClose={handleClose}
    >
      <Stack
        direction="row"
        bgcolor="white"
        alignItems="center"
        justifyContent={"space-between"}
        border={`1px solid ${type?.color ?? "black"}`}
        gap={2}
        borderRadius={3}
        minWidth={isMobile ? "90%" : "300px"}
      >
        <IconButton onClick={handleClose}>
          {type?.icon}
        </IconButton>
        <Typography color={type?.color ?? "black"} >
          {bt(massage)}
        </Typography>
        <IconButton onClick={handleClose}>
          <Close />
        </IconButton>
      </Stack>
    </Snackbar>
  );
};
export default ShowMassage;
